<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-top:150px;">Acknowledgement</h1>
<br/><br/>
<p>We thank the editorial team at Austin Macauley, without whom this book would not have been published. Many thanks, also, to the entire production staff for their sterling work.</p>
<br/>
<p>We are especially grateful to Brenda DeFazio (Rob’s wife) for her two patient proofreadings and many stylistic suggestions. Her part in shaping and grooming our manuscript was valuable beyond measure.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?423f1994